// extracted by mini-css-extract-plugin
export default {"container":"deal-filter-bar-component_container__2JZk6","truncate-table":"deal-filter-bar-component_truncate-table__CvTDs","table-text-faded":"deal-filter-bar-component_table-text-faded__J+vde","dealFilterBar":"deal-filter-bar-component_dealFilterBar__Mhc6N","searchField":"deal-filter-bar-component_searchField__dF8ef","merchantSelect":"deal-filter-bar-component_merchantSelect__Rqz8Y"};
    if(module.hot) {
      // 1792500652904
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  